import { FaCircleCheck, FaCircleExclamation } from "react-icons/fa6";

export default function FormStatus({ status, errors, successMessage }) {
  if (status === "success") {
    return (
      <div
        role="status"
        className="mb-4 flex items-start gap-3 rounded-xl border border-gold-500/40 bg-gold-500/10 p-4 text-sm text-gold-200"
      >
        <FaCircleCheck className="mt-0.5 shrink-0 text-gold-500" aria-hidden="true" />
        <p>{successMessage}</p>
      </div>
    );
  }

  if (status === "error") {
    return (
      <div
        role="alert"
        className="mb-4 flex items-start gap-3 rounded-xl border border-terracotta-500/50 bg-terracotta-500/10 p-4 text-sm text-terracotta-400"
      >
        <FaCircleExclamation className="mt-0.5 shrink-0" aria-hidden="true" />
        <ul className="space-y-1">
          {errors.map((err) => (
            <li key={err}>{err}</li>
          ))}
        </ul>
      </div>
    );
  }

  return null;
}
